export const SET_MAINTENANCE_SERVICES = 'SET_MAINTENANCE_SERVICES';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const ADD_MAINTENANCE_NOTES = 'ADD_MAINTENANCE_NOTES';



// WEBPACK FOOTER //
// ./src/store/reducers/maintenance/actionTypes.js